import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "button-header" }
const _hoisted_3 = { class: "button-title-wrapper" }
const _hoisted_4 = { class: "button-title" }
const _hoisted_5 = { class: "rates-tooltip" }
const _hoisted_6 = { class: "button-content" }
const _hoisted_7 = { class: "info-values" }
const _hoisted_8 = { class: "info" }
const _hoisted_9 = { class: "info" }
const _hoisted_10 = { class: "info" }

import { ref, computed, onMounted, onUnmounted } from "vue";
import Icon from "@/components/shared/Icon.vue";
import TooltipComponent from "@/components/shared/TooltipComponent.vue";
import { RepaymentTypes } from "@/config/enums";
import { useStore } from "vuex";

interface Props {
  readonly: boolean;
  repaymentTypeOption: any;
  selectedRepaymentTypeId?: number;
  size?: "sm" | "lg";
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RepaymentTypeButton',
  props: {
    readonly: { type: Boolean, default: true },
    repaymentTypeOption: {},
    selectedRepaymentTypeId: { default: 0 },
    size: { default: "lg" }
  },
  setup(__props: any) {

const store = useStore();

const props = __props;

const tooltipComponentRef = ref<InstanceType<typeof TooltipComponent>>();

const interestRate = computed<string>(
  () => store.state.loanConfigurationModule.selectedRatePlan?.rateDisplay || "—%",
);

const buttonStyle = computed<Record<string, number>>(() => {
  return {
    "--buttonZIndexDesktop": getTooltipZIndex(props.repaymentTypeOption?.repaymentTypeId),
  };
});
function getTooltipPosition(repaymentType: any) {
  switch (repaymentType) {
    case RepaymentTypes.Deferred:
    case RepaymentTypes.Flat:
      return "bottom-left xs-bottom-left";
    default:
      return "";
  }
}

function getTooltipZIndex(repaymentType: any) {
  switch (repaymentType) {
    case RepaymentTypes.Deferred:
    case RepaymentTypes.Regular:
      return 2;
    default:
      return 1;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    id: `repayment-type_${__props.repaymentTypeOption.repaymentTypeId}`,
    class: _normalizeClass(["repayment-option-button repayment-option-button-wrapper", [
      `repayment-option-button-${__props.size}`,
      {
        active: __props.repaymentTypeOption.repaymentTypeId === __props.selectedRepaymentTypeId,
        'default-btn': __props.repaymentTypeOption.repaymentTypeId !== __props.selectedRepaymentTypeId,
      },
    ]])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, _toDisplayString(__props.repaymentTypeOption?.repaymentTypeDetails?.name), 1)
      ]),
      _createElementVNode("div", {
        class: "tooltip-wrapper",
        style: _normalizeStyle(buttonStyle.value)
      }, [
        _createVNode(TooltipComponent, {
          ref_key: "tooltipComponentRef",
          ref: tooltipComponentRef,
          class: "bottom-left"
        }, {
          toggle: _withCtx(() => [
            _createVNode(Icon, { icon: "info" })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", null, _toDisplayString(__props.repaymentTypeOption?.repaymentTypeDetails?.tooltipText ||
                __props.repaymentTypeOption?.repaymentTypeDetails?.description), 1)
            ])
          ]),
          _: 1
        }, 512)
      ], 4)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", null, _toDisplayString(__props.repaymentTypeOption.repayment?.monthlyInSchoolPaymentLabel), 1),
          _createElementVNode("span", null, _toDisplayString(__props.repaymentTypeOption.monthlyInSchoolPaymentDisplay), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", null, _toDisplayString(__props.repaymentTypeOption.repayment?.monthlyPostSchoolPaymentLabel), 1),
          _createElementVNode("span", null, _toDisplayString(__props.repaymentTypeOption.monthlyPostSchoolPaymentDisplay), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[0] || (_cache[0] = _createElementVNode("span", null, "Interest Rate", -1)),
          _createElementVNode("span", null, _toDisplayString(__props.repaymentTypeOption?.rateDisplay || interestRate.value), 1)
        ])
      ])
    ])
  ], 10, _hoisted_1))
}
}

})